import React from 'react';

import { Badge, useWindowSize } from '@vlabs/uikit';
import { useFormContext } from 'react-hook-form';

import { useSearchApi } from '../../../api/SearchApiProvider';
import { useSearchPageTranslation } from '../../../i18n';
import st from '../Filters.module.sass';
import { FaceFiltersWithLeftPopover, FaceFiltersWithRightPopover } from '../side-menu';

function isFilterAvailable(capabilities: string[], name: string): boolean {
  return capabilities.length === 0 || capabilities.includes(name);
}

function FaceFilterForm(): React.JSX.Element {
  const { t } = useSearchPageTranslation();
  const { width } = useWindowSize();
  // @ts-expect-error требуется типизация useWindowSize
  const FaceFilters = width < 1920 ? FaceFiltersWithLeftPopover : FaceFiltersWithRightPopover;
  const api = useSearchApi();

  const { getValues } = useFormContext();
  const getFilterValue = (name: string): unknown => (
    (getValues() as Record<string, unknown>)[name]
  );
  const getFilterArray = (name: string): unknown[] => (
    ((getValues() as Record<string, unknown>)[name] as unknown[] | undefined) ?? []
  );

  return (
    <React.Fragment>
      {isFilterAvailable(api.capabilities.faceCandidateFilters, 'dateFilter') && (
        <FaceFilters.DateFilter
          badge={
            getFilterValue('create_time__lt') || getFilterValue('create_time__gte')
              ? <Badge shape="dot" />
              : undefined
          }
          className={st.MenuGroup}
          testId="dateFilter"
          value={t('filters.face_filters.creation_date')}
        />
      )}
      <div className={st.Divider} />
      <FaceFilters.ExternalIdFilter
        badge={
          getFilterArray('external_ids').length > 0
            ? <Badge shape="dot" />
            : undefined
        }
        className={st.MenuGroup}
        testId="externalIdFilter"
        value={t('filters.face_filters.external_id')}
      />
      <div className={st.Divider} />
      <FaceFilters.SimilarityFilter
        badge={getFilterValue('threshold') ? <Badge shape="dot" /> : undefined}
        className={st.MenuGroup}
        testId="similarityFilter"
        value={t('filters.face_filters.similarity')}
      />
      <div className={st.Divider} />
      <FaceFilters.ListsFilter
        badge={
          getFilterArray('list_id').length > 0
            ? <Badge shape="dot" />
            : undefined
        }
        className={st.MenuGroup}
        testId="listsFilter"
        value={t('filters.face_filters.lists')}
      />
      <div className={st.Divider} />
      {isFilterAvailable(api.capabilities.faceCandidateFilters, 'userDataFilter') && (
        <FaceFilters.UserDataFilter
          badge={
            getFilterValue('user_data')
              ? <Badge shape="dot" />
              : undefined
          }
          className={st.MenuGroup}
          testId="userDataFilter"
          value={t('filters.face_filters.user_data')}
        />
      )}
    </React.Fragment>
  );
}

export { FaceFilterForm };
